<template>
  <v-card>
    <v-card-title>
      <div class="flex-grow-1">Professional/Specialist Claims</div>
      <v-text-field v-model="search" label="Search" single-line hide-details></v-text-field>
    </v-card-title>

    <v-data-table :loading="loading" :headers="setHeadersByRole(this.user, this.headers)" :items="patient_data" :search="search">
      <template v-slot:item.CLAIM_ID="{ item }">
        <v-chip small :clickable="isClickable" @click="openClaimDetails(item.CLAIM_ID)">
          {{ item.CLAIM_ID }}
        </v-chip>
      </template>

      <template v-slot:item.AMOUNT_DEC="{ item }">
        <v-chip v-if="insurance == 'Humana'" small @click="openClaimFundTypes(item.CLAIM_ID)">
          {{ item.AMOUNT }}
        </v-chip>
        <span v-else>{{ item.AMOUNT }}</span>
      </template>

      <template v-slot:no-data> No Claims </template>
    </v-data-table>

    <ClaimDetails :insurance="insurance" :claimID="claimDetailsID" v-model="claimDetailsDialog" />
    <ClaimFundTypes
      :insurance="insurance"
      :claimID="claimFundsClaimID"
      patientID=""
      v-model="claimFundTypesDialog"
    />
  </v-card>
</template>

<script>
import axios from 'axios';
import ClaimDetails from '../claimDetails.vue';
import ClaimFundTypes from '../claimFundTypes.vue';
import { setHeadersByRole } from '../../utils/shared';

export default {
  name: 'Professional',
  props: ['patient', 'insurance', 'recordLimit'],
  components: {
    ClaimDetails,
    ClaimFundTypes,
  },
  data() {
    return {
      search: '',
      loading: false,
      claimFundTypesDialog: false,
      claimFundsClaimID: '',
      claimDetailsDialog: false,
      claimDetailsID: '',
      headers: [
        {
          text: 'Claim ID',
          sortable: false,
          value: 'CLAIM_ID',
        },
        { text: 'Claim Date', value: 'CLAIM_DATE' },
        { text: 'Provider Name', value: 'PROVIDER_NAME' },
        { text: 'Primary Diag. Code', value: 'PRIMARY_DIAG' },
        { text: 'Diagnosis Description', value: 'DIAG_DESC' },
        { text: 'Place of Service', value: 'PLACE_OF_SERVICE' },
        { text: 'Cost', value: 'AMOUNT_DEC' },
        { text: 'Status', value: 'STATUS' },
        { text: 'Line EOP Description', value: 'LINE_EOP_DESC' },
        { text: 'EOP Description', value: 'EOP_DESC' },
      ],
      patient_data: [],
    };
  },
  mounted() {
    this.getClaims();
    this.getUser();
  },
  methods: {
    async getClaims() {
      this.loading = true;
      await axios
        .get(
          `/api/patient/claims/professional/${this.insurance}/${this.patient}/${this.recordLimit}`
        )
        .then((response) => {
          this.patient_data = response.data;
          this.loading = false;
        });
    },
    setHeadersByRole: function(){
      return setHeadersByRole(this.user, this.headers)
    },
    async getUser() {
      await axios
        .get('/api/user')
        .then((response) => {
          console.log(response, "response")
          this.user = response.data[0];
        })
        .catch((err) => this.$router.push('/login'));
    },
    async openClaimDetails(ID) {
      if (this.isClickable) {
        this.claimDetailsDialog = true;
        this.claimDetailsID = ID;
      }
    },
    async openClaimFundTypes(ID) {
      this.claimFundTypesDialog = true;
      this.claimFundsClaimID = ID;
    },
  },
  computed: {
    isClickable() {
      return true;
    },
  },
};
</script>
